var React = require('react');

function BxCheckInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#2F665C","fillRule":"nonzero"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M7.845 13.822L2.357 8.333 0 10.69 7.845 18.535 24.023 2.357 21.667 0z","transform":"translate(-41.000000, -206.000000) translate(27.000000, 188.000000) translate(14.488333, 18.488333)"}))))));
}

BxCheckInline.defaultProps = {"width":"25","height":"20","viewBox":"0 0 25 20"};

module.exports = BxCheckInline;

BxCheckInline.default = BxCheckInline;
